var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-rain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-rain",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83872159,16.6913481 C8.83872159,16.6913481 7.96683443,19.8731821 7.42375218,20.8198816 C6.97903431,21.5961752 5.81667204,21.5744704 5.13735742,20.9912111 C4.45989002,20.40749 4.26500847,19.2612909 4.96695151,18.7048163 C5.8226755,18.0273489 8.83872159,16.6913481 8.83872159,16.6913481 Z M14.3268275,16.6913481 C14.3268275,16.6913481 13.4549403,19.8731821 12.9118581,20.8198816 C12.4671402,21.5961752 11.3047779,21.5744704 10.6254633,20.9912111 C9.94799591,20.40749 9.75311435,19.2612909 10.4550574,18.7048163 C11.3107814,18.0273489 14.3268275,16.6913481 14.3268275,16.6913481 Z M19.8149334,16.6913481 C19.8149334,16.6913481 18.9430462,19.8731821 18.3999639,20.8198816 C17.9552461,21.5961752 16.7928838,21.5744704 16.1135692,20.9912111 C15.4361018,20.40749 15.2412202,19.2612909 15.9431633,18.7048163 C16.7988873,18.0273489 19.8149334,16.6913481 19.8149334,16.6913481 Z M11.5912867,2 C14.1040949,2 16.2267009,3.66717419 16.9171942,5.95549857 C17.2774261,5.87205171 17.6517616,5.82386409 18.0372626,5.82386409 C20.7769052,5.82386409 23,8.04637124 23,10.7871891 C23,13.5274194 20.7769052,15.7499265 18.0372626,15.7499265 L18.0372626,15.7499265 L4.99545904,15.7499265 C2.78823089,15.7499265 1,13.9605203 1,11.7538799 C1,9.54723936 2.78823089,7.75783316 4.99545904,7.75783316 C5.35804151,7.75783316 5.7088709,7.81072201 6.04383364,7.90122072 C6.03678179,7.78897882 6.02737933,7.67791223 6.02737933,7.56449502 C6.02737933,4.49106499 8.51785667,2 11.5912867,2 Z",
    fill: "#44484C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRain);
export default __webpack_public_path__ + "static/media/ico-rain.33bc3abf1a4e29fd7be551dc5bf6b30d.svg";
export { ForwardRef as ReactComponent };